import { Header } from '../layouts/common';
import React, { useState } from 'react';

const LOGOUT_ROUTE = 'logout';

const LocaleNotFound = (): JSX.Element => {
  const [ color, setColor ] = useState('blue');

  return (
    <div className={'w-full'}>
      <Header>&nbsp;</Header>
      <div className={'container my-md'}>
        <div className={'mt-md'}>
          <h1>
            The language selected is not under translation.
            Please,&nbsp;
            <a href={`/${LOGOUT_ROUTE}`} style={{ color: color }}
              onMouseEnter={() => setColor('darkblue')}
              onMouseLeave={() => setColor('blue')}>log out</a>&nbsp;
            and then, log in selecting another language!
          </h1>
        </div>
      </div>
    </div>
  );
};

export default LocaleNotFound;
